<template>
<div class="intro-y box lg:mt-5 ">
   <div v-if="editMood">
        <div class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5">
            <h2 class="font-medium text-lg mr-auto">
                Bank Account
            </h2>
            <div @click.prevent="editMood = false" class="outline-none text-theme-3 text-lg py-5 cursor-pointer">
                <fa-icon :icon="['fas' , 'arrow-left']" /> Back
            </div>
        </div>
        <div class="p-5">
            <div class="intro-x mt-8 px-0 sm:px-10">
                <div class="intro-x flex flex-col sm:flex-row items-center mt-5">
                    <label for="inputName" class="w-full sm:w-40 font-medium text-base sm:mr-5"><fa-icon :icon="['fas' , 'money-check']" /> Bank Name</label>
                    <input type="text" class="input w-full border mt-2 flex-1" v-model="bank_info.bank_name">
                </div>
                <div class="intro-x flex flex-col sm:flex-row items-center mt-5">
                    <label for="inputEmail" class="w-full sm:w-40 font-medium text-base sm:mr-5"><fa-icon :icon="['fas' , 'address-book']" /> Bank Address</label>
                    <textarea class="input w-full border mt-2 flex-1" v-model="bank_info.bank_address"></textarea>
                </div>
                <div class="intro-x flex flex-col sm:flex-row items-center mt-5">
                    <label for="inputName2" class="w-full sm:w-40 font-medium text-base sm:mr-5"><fa-icon :icon="['fas' , 'file-signature']" /> Account Name</label>
                    <input type="text" class="input w-full border mt-2 flex-1" v-model="bank_info.account_name">
                </div>
                <div class="intro-x flex flex-col sm:flex-row items-center mt-5">
                    <label for="inputExperience" class="w-full sm:w-40 font-medium text-base sm:mr-5"><fa-icon :icon="['fas' , 'sort-numeric-up']" /> Account Number</label>
                    <input type="text" class="input w-full border mt-2 flex-1" v-model="bank_info.account_number">
                </div>
                <div class="intro-x flex flex-col sm:flex-row items-center mt-5">
                    <label for="inputSkills" class="w-full sm:w-40 font-medium text-base sm:mr-5"><fa-icon :icon="['fas' , 'fingerprint']" /> Swift Code</label>
                    <input type="text" class="input w-full border mt-2 flex-1" v-model="bank_info.swift_code">
                </div>
                <errors :errors="errors" />
                <messages :messages="messages" />
            </div>
            <div class="border-t mt-12 dark:border-dark-5 pt-5">
                <button  @click.prevent="saveBankInfo()" class="button bg-theme-1 text-white py-2 px-8">Update</button>
            </div>
        </div>
   </div>
<div  v-else >
        <div class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5">
            <h2 class="font-medium text-lg mr-auto">
                Bank Account
            </h2>
            <div @click.prevent="editMood = true" class="outline-none text-theme-6 text-lg py-5 cursor-pointer">
                <fa-icon :icon="['fas' , 'money-check-alt']" /> Edit Bank Account
            </div>
        </div>
        <div class="p-5 ">
            <div class="mx-auto w-full lg:w-11/12 px-6" >
                <div class="intro-x border-b dark:border-dark-5 mt-5" >
                    <div  class="w-32 font-medium text-base inline"> <fa-icon :icon="['fas' , 'money-check']" /> Bank Name:</div>
                    <div  class="outline-none text-lg py-5" v-if="bank_info.bank_name">{{bank_info.bank_name}}</div>
                    <div class="outline-none text-theme-6 text-lg py-5 cursor-pointer" @click.prevent="editMood = true" v-else><fa-icon :icon="['fas' , 'plus-circle']" /> Add Bank Name</div>
                </div>
                <div class="intro-x border-b dark:border-dark-5 mt-5">
                    <div  class="w-32 font-medium text-base inline"><fa-icon :icon="['fas' , 'address-book']" /> Bank Address:</div>
                    <div class="outline-none text-lg py-5" v-if="bank_info.bank_address" >{{bank_info.bank_address}}</div>
                    <div class="outline-none text-theme-6 text-lg py-5 cursor-pointer" @click.prevent="editMood = true" v-else><fa-icon :icon="['fas' , 'plus-circle']" /> Add Bank Address</div>
                </div>
                <div class="intro-x border-b dark:border-dark-5 mt-5">
                    <div  class="w-32 font-medium text-base inline"><fa-icon :icon="['fas' , 'file-signature']" /> Account Name:</div>
                    <div class="outline-none text-lg py-5" v-if="bank_info.account_name">{{bank_info.account_name}}</div>
                    <div class="outline-none text-theme-6 text-lg py-5 cursor-pointer" @click.prevent="editMood = true" v-else><fa-icon :icon="['fas' , 'plus-circle']" /> Add Account Name</div>
                </div>
                <div class="intro-x border-b dark:border-dark-5 mt-5">
                    <div  class="w-32 font-medium text-base inline"><fa-icon :icon="['fas' , 'sort-numeric-up']" />  Account Number:</div>
                    <div class="outline-none text-lg py-5" v-if="bank_info.account_number" >{{bank_info.account_number}}</div>
                    <div class="outline-none text-theme-6 text-lg py-5 cursor-pointer" @click.prevent="editMood = true" v-else><fa-icon :icon="['fas' , 'plus-circle']" /> Add Account Number</div>
                </div>
                <div class="intro-x  mt-5">
                    <div  class="w-32 font-medium text-base inline"><fa-icon :icon="['fas' , 'fingerprint']" /> Swift Code:</div>
                    <div class="outline-none text-lg py-5" v-if="bank_info.swift_code">{{bank_info.swift_code}}</div>
                    <div class="outline-none text-theme-6 text-lg py-5 cursor-pointer" @click.prevent="editMood = true" v-else><fa-icon :icon="['fas' , 'plus-circle']" /> Add Swift Code</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { RepositoryFactory } from '@/services/repositories/AuthAPI/RepositoryFactory';
const BankRepo = RepositoryFactory.get('bank');

export default {
    data() {
        return {
            errors: [],
            messages: [],
            bank_info: {},
            editMood : false
        }
    },
    created() {
        this.getBankInfo()
    },
    methods: {
        saveBankInfo: function() {
            this.errors = []
            this.messages = []
            BankRepo.update(this.user.id, this.bank_info).then(result => {
                this.messages.push("Successfuly saved.")
                setTimeout(() =>{
                    this.editMood = false 
                    this.messages.pop("Successfuly saved.") },1500) 
            }).catch(err => {
                this.errors.push("Failed to save, please try agian.")
            })
        },
        getBankInfo: async function() {
          const { data } = await BankRepo.get(this.user.id)
          this.bank_info = data
        },
    },
    computed: {
      user: function() {
        return this.$store.getters.user
      },
    }
}
</script>